import { z } from "zod";

import { LocationAlertType } from "../../../../models/LocationAlert";
import { Operators } from "../../../../models/Operators";
import { ScoreType } from "../../../../utils/score";

export const AdminLocationAlertSchema = z.object({
  internal_label_ids: z.array(z.string()),
  type: z.nativeEnum(LocationAlertType),
  details: z.object({
    health_index: z
      .object({
        operator: z.nativeEnum(Operators),
        value: z.nativeEnum(ScoreType)
      })
      .optional()
  }),
  notify_on_alert: z.boolean()
});

export type AdminLocationAlert = z.infer<typeof AdminLocationAlertSchema>;

export const defaultValues: AdminLocationAlert = {
  internal_label_ids: [""],
  type: LocationAlertType.HEALTH_INDEX,
  details: {
    health_index: {
      operator: Operators.LTE,
      value: ScoreType.A1
    }
  },
  notify_on_alert: false
};
